import Vue from 'vue';

/**
 * LibEventBus - event bus for app global events:
 *  - window resize
 */
const LibEventBus = new Vue();

export {LibEventBus};

export default LibEventBus;
